import React, { useState } from "react"
import { Link } from "react-router-dom"
import { api } from "../../include/api"
import { ERROR, SUCCESS } from "../../include/constant"
import { useNotification } from "../../Toast/ToastProvider"
import Spinner from "../add-ons/Spinner"
import { useNavigate } from "react-router-dom"

const ChangePassword = ({ apiUrl, reqConfig }) => {
  const toast = useNotification()
  const navigate = useNavigate()
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [currentPasswordError, setCurrentPasswordError] = useState('')
  const [newPasswordError, setNewPasswordError] = useState('')
  const [confirmPasswordError, setConfirmPasswordError] = useState('')

  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleCurrentPassword = (value) => {
    setCurrentPassword(value)
    setCurrentPasswordError('')
  }

  const handleNewPassword = (value) => {
    setNewPassword(value)
    setNewPasswordError('')
  }

  const handleConfirmPassword = (value) => {
    setConfirmPassword(value)
    setConfirmPasswordError('')
  }

  const handleShowPassword = (e) => {
    e.preventDefault()
    setShowPassword(!showPassword)
  }

  const setValueEmpty = () => {
    setCurrentPassword('')
    setNewPassword('')
    setConfirmPassword('')
  }

  const setErrorEmpty = () => {
    setCurrentPasswordError('')
    setNewPasswordError('')
    setConfirmPasswordError('')
  }

  const changePassword = (e) => {
    e.preventDefault()
    let error = false

    const data = {
      currentPassword: String(currentPassword),
      newPassword: String(newPassword),
      confirmPassword: String(confirmPassword),
    }

    if (data.currentPassword === '') {
      setCurrentPasswordError('Current password required')
      error = true
    }

    if (data.newPassword === '') {
      setNewPasswordError('New password required')
      error = true
    } else if (data.newPassword.length < 6) {
      setNewPasswordError('Password must be at least 6 characters')
      error = true
    }

    if (data.confirmPassword === '') {
      setConfirmPasswordError('Confirm password required')
      error = true
    } else if (data.newPassword !== data.confirmPassword) {
      setConfirmPasswordError('Passwords do not match')
      error = true
    }

    if (!error) {
      setErrorEmpty()
      setLoading(true)
      api.put(apiUrl, data, reqConfig).then(response => {
        if (response.status === 200) {
          setValueEmpty()
          setErrorEmpty()
          toast({ type: SUCCESS, message: response.data.message })
          navigate('/profile/personal-info')
        }
      }).catch(error => {
        if (error.response) {
          if (error.response.status === 403) {
            setCurrentPasswordError(error.response.data.message)
          } else if (error.response.status === 409) {
            setNewPasswordError(error.response.data.message)
          } else toast({ type: ERROR, message: error.response.data.message })
        } else toast({ type: ERROR, message: error.message })
      }).finally(() => setLoading(false))
    }
  }

  return <div className="container">
    <div className="p-32">
      <div className="d-flex align-items-center">
        <h6 className="text-xl mb-32">Change Password</h6>
      </div>
      <div className="mt-4">
        {/* Current Password */}
        <div className="position-relative w-100 mb-32">
          <input
            type={showCurrentPassword ? 'text' : 'password'}
            placeholder="Type Current Password"
            className={`form-control  ${currentPasswordError ? 'border-danger' : ''}`}
            onChange={e => handleCurrentPassword(e.target.value)}
            value={currentPassword}
            style={{
              bordeRadius: " 5px",
              fontWeight: " 400",
              outline: " none",
              width: " 100%",
              padding: " 17px 24px",
              backgroundColor: " transparent !important",
              border: " 1px solid var(--gray-100)",
              color: " hsl(var(--black))",
              lineHeight: " 1",
            }}
          />
          {currentPasswordError && (
            <div className="mt-0">
              <span className="text-danger small fw-bold m-0">{currentPasswordError}</span>
            </div>
          )}
          <i
            onClick={() => setShowCurrentPassword(prev => !prev)}
            className={`position-absolute top-50 end-0 translate-middle-y me-32 cursor-pointer ph ${showCurrentPassword ? 'ph-eye' : 'ph-eye-slash'}`}
            style={{ fontSize: '20px' }}
          />
        </div>
        <div className="position-relative w-100 mb-32">
          <input
            type={showNewPassword ? 'text' : 'password'}
            placeholder="Type New Password"
            style={{
              bordeRadius: " 5px",
              fontWeight: " 400",
              outline: " none",
              width: " 100%",
              padding: " 17px 24px",
              backgroundColor: " transparent !important",
              border: " 1px solid var(--gray-100)",
              color: " hsl(var(--black))",
              lineHeight: " 1",
            }}
            className={`form-control ${newPasswordError ? 'border-danger' : ''}`}
            onChange={e => handleNewPassword(e.target.value)}
            value={newPassword}
          />
          {newPasswordError && (
            <div className="mt-0">
              <span className="text-danger small fw-bold m-0">{newPasswordError}</span>
            </div>
          )}
          <i
            onClick={() => setShowNewPassword(prev => !prev)}
            className={`position-absolute top-50 end-0 translate-middle-y me-32 cursor-pointer ph ${showNewPassword ? 'ph-eye' : 'ph-eye-slash'}`}
            style={{ fontSize: '20px' }}
          />
        </div>
        <div className="position-relative w-100 mb-32"> {/* mb-1 = small bottom margin */}
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            placeholder="Retype New Password"
            style={{
              bordeRadius: " 5px",
              fontWeight: " 400",
              outline: " none",
              width: " 100%",
              padding: " 17px 24px",
              backgroundColor: " transparent !important",
              border: " 1px solid var(--gray-100)",
              color: " hsl(var(--black))",
              lineHeight: " 1",
            }}
            className={`form-control ${confirmPasswordError ? 'border-danger' : ''}`}
            onChange={e => handleConfirmPassword(e.target.value)}
            value={confirmPassword}
          />
          {confirmPasswordError && (
            <div className="mt-0">
              <span className="text-danger small fw-bold m-0">{confirmPasswordError}</span>
            </div>
          )}
          <i
            onClick={() => setShowConfirmPassword(prev => !prev)}
            className={`position-absolute top-50 end-0 translate-middle-y me-32 cursor-pointer ph ${showConfirmPassword ? 'ph-eye' : 'ph-eye-slash'}`}
            style={{ fontSize: '20px' }}
          />
        </div>
        {/* Submit Button */}
        <div className="d-flex justify-content-end">
          {loading ? (
            <button className="btn btn-primary d-flex align-items-center" onClick={e => e.preventDefault()}>
              <Spinner spinnerSize="sm" color="light" />
              <span className="ms-3">Change Password</span>
            </button>
          ) : (
            <button type="submit" className="btn btn-main" onClick={e => changePassword(e)}>
              Change Password
            </button>
          )}
        </div>
      </div>
    </div>
  </div>

}

export default ChangePassword